var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 36,
    rx: 6,
    fill: "#0071C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.619 13.204c-.018.116-.039.234-.062.356-.798 4.104-3.528 5.521-7.015 5.521h-1.776a.863.863 0 00-.852.732l-.909 5.774-.257 1.637a.455.455 0 00.448.526h3.15c.372 0 .689-.271.747-.64l.031-.16.593-3.769.038-.206a.758.758 0 01.749-.641h.47c3.051 0 5.44-1.241 6.138-4.831.291-1.5.14-2.752-.631-3.633a3.011 3.011 0 00-.862-.666z",
    fill: "#99C6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.784 12.87a6.239 6.239 0 00-.776-.172 9.85 9.85 0 00-1.565-.114H22.7a.757.757 0 00-.748.641l-1.009 6.401-.029.187a.863.863 0 01.852-.732h1.776c3.487 0 6.217-1.417 7.015-5.521.023-.122.044-.24.062-.356a4.25 4.25 0 00-.835-.333z",
    fill: "#CCE2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.952 13.225a.757.757 0 01.748-.641h4.743a9.85 9.85 0 011.565.114 6.239 6.239 0 01.955.229c.235.078.454.17.656.277.237-1.516-.001-2.549-.82-3.484-.903-1.03-2.532-1.47-4.616-1.47h-6.051a.865.865 0 00-.855.732l-2.52 16.003a.52.52 0 00.512.602h3.736l.938-5.96 1.01-6.402z",
    fill: "#fff"
  })));
}
export default SvgPaypal;